import { useEffect, useRef } from 'react';
import Button from '@/components/atoms/Button/Button';
import useAnalytics from '@/hooks/useAnalytics';
import Icon from '@/components/atoms/Icon';

export const SharedVideoTimedOut = ({
  customHeader,
  customMessage,
  isSignedIn,
  onClickOpenInContentLab,
  customProperties
}: {
  customHeader?: string;
  customMessage?: string;
  isSignedIn?: boolean;
  onClickOpenInContentLab?: () => void;
  customProperties: object | null;
}) => {
  const { trackSharedPageWithoutRemotion } = useAnalytics();

  const hasLoggedRef = useRef(false);

  useEffect(() => {
    if (hasLoggedRef.current || customProperties === null) {
      return;
    }
    trackSharedPageWithoutRemotion({ properties: customProperties });
    hasLoggedRef.current = true;
  }, [trackSharedPageWithoutRemotion, customProperties]);

  return (
    <div className="flex size-full flex-col items-center justify-center text-sm">
      <Icon name="IconAlertTriangle" color="#63748A" size={24} />
      <div className="mt-3 text-center font-medium text-[#63748A]">
        {customHeader ??
          (isSignedIn
            ? 'Share link expired. Open the clip in Content Lab to reactivate it'
            : 'Shared video link expired')}
      </div>
      <div className="mt-1 text-center font-light text-[#63748A]">
        {customMessage ??
          (isSignedIn
            ? 'Your viewers will see this message on the page while the link is expired: "This video is no longer available. Please contact the author to resolve this issue."'
            : 'This video is no longer available. Please contact the author to resolve this issue.')}
      </div>
      {isSignedIn && onClickOpenInContentLab && (
        <Button
          className="mt-2"
          variation="filled"
          onClick={onClickOpenInContentLab}
          trackingId="edit-in-content-lab-button"
        >
          Open in Content Lab
        </Button>
      )}
    </div>
  );
};
